export enum Policies {
    // These should be existing policies in the back-end.
    Admin = 'Admin',
    View_Home = "View.Home",
    View_Cebe_Home = "View.Cebe.Home",
    View_Centro_Home = "View.Centro.Home",
    View_Admin_Home = "View.Admin.Home",
    View_Map = "View.Map",
}